module.exports = __webpack_public_path__ + "img/DurchDenKiez.60f8b13e.svg";